import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import TextAreaWithEditorsOptions from './TextAreaWithEditorsOptions'
import { modal } from 'store/entities/modal/actions'
import AddingLinkModal from 'app/domains/common/Modals/AddingLinkModal/index'

const mergeProps = (stateProps, { dispatch, ...dispatchProps }, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  showModal: textareaRef => {
    const { selectionStart, selectionEnd } = textareaRef
    const initialValues = {
      text: textareaRef.value.slice(selectionStart, selectionEnd),
    }
    return dispatch(
      modal.show(AddingLinkModal, {
        size: 'sm',
        textareaRef,
        initialValues,
        formName: ownProps.meta.form,
        field: ownProps.input.name,
      })
    )
  },
})

export default connect(null, null, mergeProps)(withTranslation('admin')(TextAreaWithEditorsOptions))
